import React, { useContext, useEffect } from 'react';
// Chakra imports
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Switch,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
// Assets
import signInImage from '../../assets/img/signInImage.png';
import { Link, useNavigate } from 'react-router-dom';
import { Globle_app_context } from '../../context/globle_context';

function SignIn() {
  let navigate =useNavigate()
  useEffect(()=>{
    let is_auth = localStorage.getItem('my_auth') || undefined
    if(is_auth){
        navigate('/home')
    }
  },[])
  // Chakra color mode
  const titleColor = useColorModeValue('teal.300', 'teal.200');
  const textColor = useColorModeValue('gray.400', 'white');
  const bgColor = useColorModeValue("white", "gray.700");
  const {
    hendleSign_inForm_input,
    user_sign_in,
    sign_in_state_loading
  } = useContext(Globle_app_context);
  
  return (
    <Flex
      h={{ sm: 'initial', md: '75vh', lg: '75vh' }}
      w="100%"
      maxW="1044px"
      mx="auto"
      justifyContent="center"
      className={"translate-y-[55px]"}
      alignItems="center"
      mb="0px"
      pt={{ sm: '100px', md: '0px' }}
    >
      <Flex
        borderRadius="15px"
        mx={{ base: '100px' }}
        bg={bgColor}
        boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)"
        alignItems="center"
        justifyContent="center"
        style={{ userSelect: 'none' }}
        w={{ base: '100%', md: '50%', lg: '42%' }}
        // h={{ sm: 'initial', md: '75vh', lg: '80vh' }}
        className="bg-white border-[1px] translate-y-[55px]"
      >
        <Flex
          direction="column"
          w="100%"
          background="transparent"
          p="48px"
          mt={{ md: '0px', lg: '0px' }}
        >
          <Heading className="text-[#51bcfa]" fontSize="32px" mb="10px">
            Welcome Back
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            className="text-gray-400"
            fontWeight="bold"
            fontSize="14px"
          >
            Enter your email and password to sign in
          </Text>
          <FormControl>
            <form onSubmit={(e) => user_sign_in(e)}>
              <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                Email
              </FormLabel>
              <Input
                onChange={(e) => hendleSign_inForm_input(e)}
                name="username"
                borderRadius="15px"
                mb="24px"
                fontSize="sm"
                type="text"
                placeholder="Your email adress"
                size="lg"
              />
              <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                Password
              </FormLabel>
              <Input
                onChange={(e) => hendleSign_inForm_input(e)}
                name="password"
                borderRadius="15px"
                mb="36px"
                fontSize="sm"
                type="password"
                placeholder="Your password"
                size="lg"
              />

              <Button
                isLoading={sign_in_state_loading}
                isDisabled={sign_in_state_loading}
                fontSize="10px"
                type="submit"
                bg="#51bcfa"
                w="100%"
                h="45"
                mb="20px"
                color="white"
                mt="20px"
                _hover="#b799be"
                _active={{
                  bg: '#51bcfa',
                }}
              >
                SIGN IN
              </Button>
            </form>
          </FormControl>
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            maxW="100%"
            mt="0px"
          >
            <Text className="text-gray-400" fontWeight="medium">
              Don't have an account?
              <Link to={'/signup'}>
                <Text
                  className="text-[#51bcfa]"
                  as="span"
                  ms="5px"
                  fontWeight="bold"
                >
                  Sign Up
                </Text>
              </Link>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default SignIn;
